import React, { Component } from 'react';
import {Helmet} from 'react-helmet';

class Pricing extends Component {

handleClick = (event) => {
  console.log('button value ' + event.target.value);
  window.location.href = '/contact.html?plan=' + event.target.value;
}

  render() {
    return (
        <div className="page pricing" id="page">
          <Helmet>
            <title>rewardeclub | Pricing plans.</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
            <meta name="description" content="Various pricing plans based on the size of businesses." />
            <meta name="keywords" content="eclub, e-club, customer eclub, customer e-club, customers eclub, customers e-club, manage eclub, eclub management, manage e-club, e-club management, connect business and customers" />
            <meta name="robots" content="index, follow" />
          </Helmet>
          <div className="pricing-row">
            <div className="pricing-box box-left">
              <div className="heading">1 Location</div>
              <div className="body">
                $49 / month
                <p/>
                One-Time Setup fee: $199
                <p/>
                <button className="pricing-contact" value="1" onClick={this.handleClick}>Contact</button>
              </div>
            </div>
            <div className="pricing-box box-right">
              <div className="heading">2-5 Locations</div>
              <div className="body">
                $99 / month
                <p/>
                One-Time Setup fee: $399
                <p/>
                <button className="pricing-contact" value="2" onClick={this.handleClick}>Contact</button>
              </div>
            </div>
            <div className="pricing-box box-left">
              <div className="heading">6-10 Locations</div>
              <div className="body">
                $199 / month
                <p/>
                One-Time Setup fee: $999
                <p/>
                <button className="pricing-contact" value="3" onClick={this.handleClick}>Contact</button>
              </div>
            </div>
            <div className="pricing-box box-right">
              <div className="heading">11-20 Locations</div>
              <div className="body">
                $299 / month
                <p/>
                One-Time Setup fee: $1499
                <p/>
                <button className="pricing-contact" value="4" onClick={this.handleClick}>Contact</button>
              </div>
            </div>
            <div className="pricing-box box-left">
              <div className="heading">21+ Locations</div>
              <div className="body">
                Custom Plan
                <p/>
                <button className="pricing-contact" value="5" onClick={this.handleClick}>Contact</button>
                <p/>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default Pricing;



// WEBPACK FOOTER //
// ./src/page/Pricing.js